module.exports = __webpack_public_path__ + "img/squirrel.e6dbc7fe.svg";